module.exports = __webpack_public_path__ + "static/media/like.8e502a44.svg";